<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar title="现场问题" left-text="返回" left-arrow @click-left="toBack()" id="topbar"/>

    <div style="padding: 20px;">
      <h2 style="font-weight: bold">问题清单</h2>

      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false">
        <div v-for="(item,index) in list" :key="index" style="border: 1px solid;width: 100%;margin-top: 10px;height: 70px;border-radius: 10px;background-color: white">
          <div style="width: 70%;float: left;height: 100%;font-size: 14px;font-weight: bold">
            <p style="padding: 5px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{item.problemSubclass}}</p>
            <p style="padding: 5px">时间：{{ item.createTime }}</p>
          </div>
          <div style="width: 30%;float: right;height: 100%;padding: 10px;text-align: right;line-height: 44px">
            <a style="color: #ff901e" @click="detailProblem(item)">查看详情</a>
          </div>
        </div>
      </van-list>

      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false">
        <h2 style="font-weight: bold">问题暂存</h2>
        <div v-for="(item,index) in listCache" :key="index" v-if="companyId===item.companyId" style="border: 1px solid;width: 100%;margin-top: 10px;height: 70px;border-radius: 10px;background-color: white">
          <div style="width: 70%;float: left;height: 100%;font-size: 14px;font-weight: bold">
            <p style="padding: 5px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">{{item.problemSubclass}}</p>
            <p style="padding: 5px">时间：{{ item.inspectionDate }}</p>
          </div>
          <div style="width: 30%;float: right;height: 100%;padding: 10px;text-align: right;line-height: 0">
            <van-button @click="submitProblem(item.id, index)" :loading="loadings[index]" color="#1B75F6" size="small" style="float: right;margin-top: 7px">提交</van-button>
          </div>
        </div>
      </van-list>
    </div>

    <div style="height: 150px"></div>

    <div style="text-align: center;width: 100%;position: fixed;bottom:10px">
      <van-button type="warning" @click="exitCheck()">结束检查</van-button>
      <van-button type="info" style="margin-left: 50px" @click="toProblem()"><van-icon name="plus"/>添加问题</van-button>
    </div>

    <van-popup v-model="signModal" position="bottom" :style="{ height: '100%' }" style="z-index: 99999">
      <van-nav-bar left-text="返回" left-arrow @click-left="signBack" id="topbar"/>
      <div class="esigns" ref="signDivRef">
        <sign-canvas class="sign-canvas" ref="signCanvasRef" :options="options" v-model="signCanvasVal"/>
        <div class="sign-text2">被检查单位对接人签字</div>
        <div class="sign-text1" @click="handleClear">清空</div>
        <div class="sign-text" @click="handleConfirm">提交</div>
      </div>
      <div v-show="subLoading" style="background-color: rgba(0, 0, 0, 0.5);position: absolute;z-index: 999;height: 120%;width: 100%;top: -20%">
        <van-loading  type="spinner" style="position: absolute;top: 55%;left: 50%;z-index: 999" />
      </div>

    </van-popup>

  </div>
</template>
<script>
import $ from '@/fly'
import SignCanvas from "sign-canvas";
import Vue from 'vue';
import {Toast, Dialog} from 'vant';
import vueEsign from 'vue-esign'
import {ProblemStore, WorkRecordCheckItemRemarksStore} from '@/libs/indexedDB'
import {dataURLtoFile} from '@/libs/coverter'
import {WorkRecordsStore} from '@/libs/indexedDB'

Vue.use(vueEsign)
Vue.use(Dialog);
export default {
  name: "problemCheckTaskIndex",
  components:{
    SignCanvas
  },
  data() {
    return {
      rotatedImageDataUrl: '',
      signCanvasVal: null,
      options: {
        isDpr: true, //是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]    正方形线帽
        lineJoin: "bevel", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: 350, //canvas宽高 [Number] 可选
        canvasHeight: 370, //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        bgColor: "#ffffff", //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: "#808080", //网格颜色  [String] 可选
        writeWidth: 5, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: "#101010", // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: "png", //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
      maskShow:false,
      clientHeight: window.screen.height,
      list: [],
      loading: false,
      finished: false,
      signModal: false,
      listCache: [],
      loadings: [],
      companyId: '',
      workRecordData:{},
      subLoading: false
    }
  },
  methods: {
    //签字返回
    signBack(){
      if(!this.maskShow){
        this.signModal=false
      }
    },
    //暂存问题提交
    async submitProblem(id, index) {
      this.$set(this.loadings, index, true)
      {
        const problem = await ProblemStore.get(id)
        const {problemPhotoFiles} = problem
        let aIds = []
        if (problemPhotoFiles && problemPhotoFiles.length)
          aIds = await $.multiUploadAddWaterMarking(problemPhotoFiles.map(f => dataURLtoFile(f.url, f.filename)), null, problem.address, problem.longitudeAndLatitude)
        await $.post('problem',
          JSON.stringify([{...problem, problemPhotoFiles: null, problemPhotos: aIds.join(',')}]),
          {contentType: 'application/json'}
        ).catch(err => Toast.fail(err.message))
        await ProblemStore.delete(id)
        this.listCache.splice(this.listCache.findIndex(p => p.id === id), 1)
        this.getData()
        Toast.success('提交成功！')
      }
      this.loadings.splice(index, 1)
    },
    //清除
    handleClear() {
      this.$refs.signCanvasRef.canvasClear();
    },
    //提交
    handleConfirm() {
      const _this = this;
      this.maskShow = true
      this.subLoading = true
      // 转成文件
      let res1 = this.$refs.signCanvasRef.saveAsImg();
      const img = new Image();
      img.src = res1;
      img.onerror = (err) => {
        this.signModal = false
        this.subLoading = false
        Toast.fail({
          message: `签名文件异常${err || '文件异常，请重试'}`,
          duration: 5000
        });
        console.error('签名文件异常：', err);
      };
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 设置canvas大小与图片相同 计算旋转后的宽高
        const rotatedWidth = img.height;
        const rotatedHeight = img.width;

        // 设置canvas宽高为旋转后的宽高
        canvas.width = rotatedWidth;
        canvas.height = rotatedHeight;
        // 旋转图片
        ctx.translate(rotatedWidth / 2, rotatedHeight / 2);
        ctx.rotate((-90 * Math.PI) / 180); // 旋转指定角度
        ctx.drawImage(img, -img.width / 2, -img.height / 2, img.width, img.height);

        // 获取旋转后的图片数据
        this.rotatedImageDataUrl = canvas.toDataURL('image/png');
        const file = _this.dataURLtoFile(this.rotatedImageDataUrl);
        //调用接口
        $.uploadSignFile(file, {businessModule: 'OIL_WASTE_WATER_DOSING_SIGN'}).then(res => {
          if (res != null && res !== '') {
            let problemIds = localStorage.getItem('problemIds')
            let task = JSON.parse(localStorage.getItem('task'))
            task.submitStatus = 1
            let proIdsOld = '';
            for (let i = 0; i < this.list.length; i++) {
              if (proIdsOld === '') {
                proIdsOld = this.list[i].id
              } else {
                proIdsOld += ',' + this.list[i].id
              }
            }
            if (problemIds !== '' && problemIds != null) {
              const merged = [...new Set([
                ...(proIdsOld ? proIdsOld.toString().split(',') : []),
                ...(problemIds ? problemIds.toString().split(',') : [])
              ])]; // 合并并去重
              problemIds = merged.join(',');
            } else {
              problemIds = proIdsOld
            }
            task.problemIds = problemIds
            localStorage.setItem('task', JSON.stringify(task))
            $.put('problemCheckTask', {
              'id': task.id,
              'checkUserId': task.checkUserId,
              'companyId': task.companyId,
              'problemIds': task.problemIds,
              'projectId': task.projectId,
              'submitDate': new Date(),
              'submitStatus': task.submitStatus,
              'signFileId': res,
              'createDate': new Date()
            }).then(() => {
              if (this.workRecordData) {
                const workRecordData = JSON.parse(this.workRecordData.workRecords)
                this.$set(workRecordData,'signPhotosId',res)
                $.put('workRecords/workSubmit',
                  {
                    workRecords: JSON.stringify(workRecordData),
                    remarksList: this.workRecordData.remarksList
                  },
                  {contentType: 'application/json'}
                ).then(() => {
                  Toast.success('结束检查成功！')
                  if (localStorage.getItem('isCacheWork')==='2') {
                    $.delete('/workRecords/delCloudCacheByCode',{
                      projectId: localStorage.getItem('projectId'),
                      companyId: localStorage.getItem('companyId'),
                      cacheCode: localStorage.getItem('cloudCacheCode')
                    }).catch(error => {
                      console.log('云端待提交记录提交后删除失败，原因为：',error)
                    })
                  }
                  if (localStorage.getItem('workRecordItem')) {
                    localStorage.removeItem('workRecordItem')
                  }
                  localStorage.removeItem('workRecordData')
                  WorkRecordsStore.delete(this.workRecordData.workRecordsId)
                  WorkRecordCheckItemRemarksStore.delete(this.workRecordData.workRecordsId)
                  this.signModal = false
                  this.subLoading = false
                  this.$router.push({name: 'project-companyOperation'})
                }).catch(err => {
                  this.signModal = false
                  this.subLoading = false
                  Toast.fail({
                    message: `${err?.message || '操作失败，请重试'}`,
                    duration: 5000
                  });
                  console.error('提交异常详情：', err);
                })
              } else {
                Toast.success('结束检查成功！')
                this.signModal = false
                this.subLoading = false
                this.$router.back()
              }
            }).catch(err => {
              this.signModal = false
              this.subLoading = false
              Toast.fail({
                message: `${err?.message || '操作失败，请重试'}`,
                duration: 5000
              });
              console.error('提交异常详情：', err);
            })
          }
        }).catch(err => {
          this.signModal = false
          this.subLoading = false
          Toast.fail({
            message: `${err?.message || '操作失败，请重试'}`,
            duration: 5000
          });
          console.error('提交异常详情：', err);
        })
        this.maskShow = false
      }
    },
    // 将base64转换为file
    dataURLtoFile(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let ia = new Uint8Array(n);
      while (n--) {
        ia[n] = bytes.charCodeAt(n);
      }
      return new File([ia], "easign.jpg", {type: mime});
    },
    //返回
    toBack() {
      if (localStorage.getItem('isCacheWork')==='2') {
        localStorage.setItem('isCacheWork','0');
        localStorage.setItem('indexdbCacheId',this.workRecordData.workRecordsId);
        localStorage.removeItem('cloudCacheCode');
      }
      this.$router.back();
    },
    //结束检查
    exitCheck() {
      this.signModal = true
    },
    //添加问题
    toProblem() {
      this.$router.push({name: 'project-problem'});
    },
    //问题详情
    detailProblem(item) {
      localStorage.setItem('detailProblem',JSON.stringify(item))
      this.$router.push({name: 'project-problemDetail'})
    },
    //获取数据列表
    getData() {
      let companyId = localStorage.getItem('companyId')
      let projectId = localStorage.getItem('projectId')
      let userId = JSON.parse(localStorage.getItem('USER')).userId
      $.get('problem/getData', {'userId': userId, 'companyId': companyId, 'projectId': projectId}).then(res => {
        this.list = res
        // 加载状态结束
        this.loading = false;
        this.finished = true;
      })
    }
  },
  mounted() {
    this.options.canvasHeight = window.innerHeight-70
    this.options.canvasWidth = window.innerWidth-60
    this.companyId = localStorage.getItem('companyId');
    this.workRecordData = JSON.parse(localStorage.getItem('workRecordData'))
    this.getData()
  },
  async created() {
    let companyId = localStorage.getItem('companyId')
    let projectId = localStorage.getItem('projectId')
    let userId = JSON.parse(localStorage.getItem('USER')).userId

    this.listCache = (await ProblemStore.toArray()).sort((f, s) => s.id - f.id)
    this.loadings = this.list.map(() => false)

    $.get('problem/noSubmitIds', {
      'userId': userId,
      'companyId': companyId,
      'projectId': projectId
    }).then(res => {
      localStorage.setItem('problemIds', res)
    })
  }
}
</script>

<style scoped>

.esigns {
  padding: 110px 40px 40px 40px;
}

#topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: #1B75F6;
}
.sign-text{
  text-align: center;
  width: 200px;
  font-size: 46px;
  background-color: rgba(27, 117, 246, 0.9);
  border-radius: 16px;
  color: #ffffff;
  position: fixed;
  top: 89.8%;
  left: -50px;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg);
  /* IE 9 */
  -moz-transform:rotate(90deg);
  /* Firefox */
  -webkit-transform:rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
  /* Opera */
}

.sign-text1{
  text-align: center;
  width: 200px;
  font-size: 44px;
  background-color: #e1e1e1;
  border-radius: 16px;
  color: #000000;
  position: fixed;
  top: 69.8%;
  left: -50px;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg);
  /* IE 9 */
  -moz-transform:rotate(90deg);
  /* Firefox */
  -webkit-transform:rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
  /* Opera */
}

.sign-text2{
  text-align: center;
  width: 290px;
  font-size: 28px;
  color: #1C75F6;
  position: fixed;
  top: 17.5%;
  left: -90px;
  transform:rotate(90deg);
  -ms-transform:rotate(90deg);
  /* IE 9 */
  -moz-transform:rotate(90deg);
  /* Firefox */
  -webkit-transform:rotate(90deg);
  /* Safari 和 Chrome */
  -o-transform:rotate(90deg);
  /* Opera */
}

.sign-canvas{
  position: fixed;
  left: 100px;
  border: 1px solid #c5c5c5;
}
</style>
